<template>
  <div class="content">
    <div class="conts">
      <div class="cont_left">
        <div class="ces">
          <span class="context">当票编号:</span>
          <el-input v-model="input" placeholder="请输入票号"  clearable  class="con_inp" />
          <el-button type="primary" @click="queryClik" :class="{showBt:showTitle}">点击查询</el-button>
        </div>
        <div class="ces">
          <span class="context">当户名字:</span>
          <el-input
            v-model="inputs"
            placeholder="请输入当户名字"
            clearable
             class="con_inp"
          />
          <el-button type="primary" @click="queryClikname" :class="{showBt:showTitle}"
            >点击查询</el-button
          >
        </div>
        <div class="ces">
          <span class="context">当户电话:</span>
          <el-input
            v-model="inputes"
            placeholder="请输入电话"
            clearable
            class="con_inp"
          />
          <el-button type="primary" @click="queryCliktel" :class="{showBt:showTitle}"
            >点击查询</el-button
          >
        </div>
      </div>

      <div class="cont_left">
        <div class="ces">
          <span class="context">开始日期:</span>
           <el-date-picker
            v-model="inputc"
            type="date"
            placeholder="点击选择日期"
            value-format="yyyy-MM-dd"
            class="con_inp"
          >
    </el-date-picker>
          <el-button type="primary" @click="queryClikdate"  :class="{showBt:showTitle}"
            >点击查询</el-button
          >
        </div>
        <div class="ces">
          <span class="context">到期日期:</span>
         
              <el-date-picker
                v-model="inputcs"
                type="date"
                placeholder="点击选择日期"
                value-format="yyyy-MM-dd"
                class="con_inp"
              >
      </el-date-picker>
          <el-button type="primary" @click="queryClikenddate" :class="{showBt:showTitle}"
            >点击查询</el-button
          >
        </div>
        <div class="ces">
          <span class="context">证件号码:</span>
          <el-input
            v-model="inputces"
            placeholder="请输入证件号码"
            clearable
             class="con_inp"
          />
          <el-button type="primary" @click="queryClikidcard" :class="{showBt:showTitle}">
            
            <span>{{loading==true?'查询中...':'点击查询'}}</span>
              </el-button>
         
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";
export default {
  name: "query",
  data() {
    return {
      //输入框值
      input: "",
      inputs: "",
      inputes: "",

      //第二栏输入框的值
      inputc: "",
      inputcs: "",
      inputces: "",


      //ACCESS_TOKEN令牌
      ACCESS_TOKEN: "",

      //计算出的逾期|绝当的终止日期
      day: "",

      //结束日期标识
      shows:true,

      showTitle:false,

      loading:false

    };
  },
  props:{
    message:{
      type:String,
      required:true
    }
  },

  methods: {
    //通过票号查询数据
    queryClik() {
      if(this.input !==""){
        if(this.message == "民品"){
            this.axios
          .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
            env: `${this.userData.env}`,
            query:
              'db.collection("add_data").where({ticketnumber:"' +
              this.input +
              '"}).limit(1000).get()',
          })
          .then((res) => {
            res.data.data.forEach((element, index, array) => {
              array[index] = JSON.parse(element);
            });
            if(res.data.data.lenght !==0){
               this.$emit("child-event", res.data.data, this.day);
            }else{
               this.$message.error('未查询到该票号');
            }
           
          });

        }else if(this.message == "汽车"){
           this.axios
          .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
            env: `${this.userData.env}`,
            query:
              `db.collection("car_data").where({piaonum:"${this.input}"}).limit(1000).get()`,
          })
          .then((res) => {
            res.data.data.forEach((element, index, array) => {
              array[index] = JSON.parse(element);
            });
            this.$emit("child-event", res.data.data, this.day);
          });
        }else{
          //房产
            this.axios
          .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
            env: `${this.userData.env}`,
            query:
              `db.collection("house").where({Piaonumber:"${this.input}"}).limit(1000).get()`,
          })
          .then((res) => {
            res.data.data.forEach((element, index, array) => {
              array[index] = JSON.parse(element);
            });
            this.$emit("child-event", res.data.data);
          });

          
        }

      }else{
           this.$message.error('请输入要查找的票号');
      }
     
    },

    //通过名字查询数据
    queryClikname() {
      if(this.inputs !=="" ){
        if(this.message == "民品"){
            this.axios
          .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
            env: `${this.userData.env}`,
            query:
              'db.collection("add_data").where({name:"' +
              this.inputs +
              '"}).limit(1000).get()',
          })
          .then((res) => {
            res.data.data.forEach((element, index, array) => {
              array[index] = JSON.parse(element);
            });
            this.$emit("child-event", res.data.data, this.day);
          });
        }else if(this.message == "汽车"){
           this.axios
          .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
            env: `${this.userData.env}`,
            query:
              'db.collection("car_data").where({name:"' +
              this.inputs +
              '"}).limit(1000).get()',
          })
          .then((res) => {
            res.data.data.forEach((element, index, array) => {
              array[index] = JSON.parse(element);
            });
            this.$emit("child-event", res.data.data, this.day);
          })

        }else{
          //房产
            this.axios
          .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
            env: `${this.userData.env}`,
            query:
              'db.collection("house").where({Dhname:"' +
              this.inputs +
              '"}).limit(1000).get()',
          })
          .then((res) => {
            res.data.data.forEach((element, index, array) => {
              array[index] = JSON.parse(element);
            });
            // console.log(res)
            this.$emit("child-event", res.data.data);
          })

         
        }
        
      }else{
        this.$message.error('请输入要查找的当户姓名');
      }
      
    },

    //通过电话查询数据
    queryCliktel() {
      if(this.inputes !==""){
        if(this.message == "民品"){
          this.axios
          .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
            env: `${this.userData.env}`,
            query:
              'db.collection("add_data").where({telnumber:"' +
              this.inputes +
              '"}).limit(1000).get()',
          })
          .then((res) => {
            res.data.data.forEach((element, index, array) => {
              array[index] = JSON.parse(element);
            });
            this.$emit("child-event", res.data.data, this.day);
          });
        }else if(this.message == "汽车"){
           this.axios
          .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
            env: `${this.userData.env}`,
            query:
              'db.collection("car_data").where({tel:"' +
              this.inputes +
              '"}).limit(1000).get()',
          })
          .then((res) => {
            res.data.data.forEach((element, index, array) => {
              array[index] = JSON.parse(element);
            });
            this.$emit("child-event", res.data.data, this.day);
          });
        }else{
          //房产
           this.axios
          .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
            env: `${this.userData.env}`,
            query:
              'db.collection("house").where({tel:"' +
              this.inputes +
              '"}).limit(1000).get()',
          })
          .then((res) => {
            res.data.data.forEach((element, index, array) => {
              array[index] = JSON.parse(element);
            });

            this.$emit("child-event", res.data.data);
          });

        
        }
       
      }else{
        this.$message.error('请输入要查找的当户电话');
      }
     
    },

    //通过开始日期查询数据
    queryClikdate() {
      if(this.inputc !==""){
        if(this.message == "民品"){
          this.axios
          .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
            env: `${this.userData.env}`,
            query:
              `db.collection("add_data").where({startdate:"${this.inputc}"}).limit(1000).get()`,
          })
          .then((res) => {
            res.data.data.forEach((element, index, array) => {
              array[index] = JSON.parse(element);
            });
            this.$emit("child-event", res.data.data, this.day);
          });
        }else if(this.message == "汽车"){
           this.axios
          .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
            env: `${this.userData.env}`,
            query:
              `db.collection("car_data").where({startDate:"${this.inputc}"}).limit(1000).get()`,
          })
          .then((res) => {
            res.data.data.forEach((element, index, array) => {
              array[index] = JSON.parse(element);
            });
            this.$emit("child-event", res.data.data, this.day);
          });
        }else{
          //房产
            this.axios
          .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
            env: `${this.userData.env}`,
            query:
              `db.collection("house").where({DdqxEndDate:"${this.inputc}"}).limit(1000).get()`,
          })
          .then((res) => {
            res.data.data.forEach((element, index, array) => {
              array[index] = JSON.parse(element);
            });
            this.$emit("child-event", res.data.data);
          });


        }
       
      }else{
        this.$message.error('请输入要查找的开始日期');
      }
     
    },

    //通过结束日期查询数据
    queryClikenddate() {
      if(this.inputcs !==""){
        if(this.message == "民品"){
          this.axios
          .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
            env: `${this.userData.env}`,
            query:
              'db.collection("add_data").where({enddate:"' +
              this.inputcs +
              '"}).limit(1000).get()',
          })
          .then((res) => {
            res.data.data.forEach((element, index, array) => {
              array[index] = JSON.parse(element);
            });
            this.$emit("child-event", res.data.data, this.day,this.shows);
          });
        }else if(this.message == "汽车"){
           this.axios
          .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
            env: `${this.userData.env}`,
            query:
              'db.collection("car_data").where({DateClosed:"' +
              this.inputcs +
              '"}).limit(1000).get()',
          })
          .then((res) => {
            res.data.data.forEach((element, index, array) => {
              array[index] = JSON.parse(element);
            });
            this.$emit("child-event", res.data.data, this.day,this.shows);
          });
        }else{

          //查询房产业务

            this.axios
          .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
            env: `${this.userData.env}`,
            query:
              'db.collection("house").where({DdqxEndDate:"' +
              this.inputcs +
              '"}).limit(1000).get()',
          })
          .then((res) => {
            res.data.data.forEach((element, index, array) => {
              array[index] = JSON.parse(element);
            });
            this.$emit("child-event", res.data.data,);
          });

        }
        
      }else{
        this.$message.error('请输入要查找的结束日期');
      }
     
    },

    //通过身份证号查询
    queryClikidcard() {
      if(this.inputces !==""){
        if(this.message == "民品"){
          this.axios
          .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
            env: `${this.userData.env}`,
            query:
              'db.collection("add_data").where({cardnumber:"' +
              this.inputces +
              '"}).limit(1000).get()',
          })
          .then((res) => {
            res.data.data.forEach((element, index, array) => {
              array[index] = JSON.parse(element);
            });
            this.$emit("child-event", res.data.data, this.day);
          });
        }else if(this.message == "汽车"){
              this.axios
          .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
            env: `${this.userData.env}`,
            query:
              'db.collection("car_data").where({cardnumber:"' +
              this.inputces +
              '"}).limit(1000).get()',
          })
          .then((res) => {
            res.data.data.forEach((element, index, array) => {
              array[index] = JSON.parse(element);
            });
            this.$emit("child-event", res.data.data, this.day);
          });
        }else{
          this.loading = true

               this.axios
          .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
            env: `${this.userData.env}`,
            query:
              'db.collection("house").where({Cardnumber:"' +
              this.inputces +
              '"}).limit(1000).get()',
          }).then(res=>{
            res.data.data.forEach((element, index, array) => {
              array[index] = JSON.parse(element);
            });
            this.loading = false
           
            this.$emit("child-event", res.data.data);

          })
           
        }
        
      }else{
        this.$message.error('请输入要查找的身份证号码');
      }
     
    },
  },
  created() {
    // this.ACCESS_TOKEN = localStorage.getItem("ACCESS_TOKEN"); //获取到this.ACCESS_TOKEN

       //获取到this.ACCESS_TOKEN
     this.getTokens()

     //获取当前登录的用户数据
    this.getUserToken()


    this.day = dayjs().subtract(5, "day").format("YYYY-MM-DD"); //计算绝当|逾期的终止日期
  },
  mounted() {
      if(document.body.clientWidth < 1446){
            this.showTitle = true
        }else{
            this.showTitle = false
        }
  },
};
</script>

<style scoped>
.content {
  width: 100%;
}
.conts {
  width: 100%;
  height: 150px;
  margin: 10px 0;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
}
.cont_left {
  width: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.ces {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  margin: 4px 0;
  width: 100%;
  
}
.context{
  width: 47px;
}

.con_inp{
  width: 50%;
}
.showBt{
        padding: 10px 6px;
    }
</style>
